module.exports = __webpack_public_path__ + "img/ggnia_cover.973430df.jpg";